<template>
  <section-collapseable
    hide-initial-when-expanded
    :is-loading="isLoading"
  >
    <div class="timeline">
      <div>
        <form-field-checkbox-buttons
          v-model="selectedFilters"
          :items="availableFilters"
          @change="updateSelectedItems"
        ></form-field-checkbox-buttons>
      </div>

      <timeline-list
        :items="timelineItems"
        is-on-lead-modal
        override-empty
      >
        <timeline-item
          type="Record Created"
          :date="recordCreatedAt"
          :by-name="recordCreatedBy"
          icon="plus"
          outlined
          last
        ></timeline-item>
      </timeline-list>
    </div>
  </section-collapseable>
</template>

<script>
import TimelineList from "../../../components/timeline/TimelineList";
import TimelineItem from "../../../components/timeline/TimelineItem";
import dates from "../../../services/dates";
import api from "../../../api";
import LocalStorage from "../../../services/localStorage";

export default {
  name: "LeadTimeline",
  components: {TimelineItem, TimelineList},
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showMoreIsLoading: false,
      selectedFilters: [
        'notes',
        'comms',
        'activities',
      ],
      availableFilters: [
        {
          value: 'notes',
          label: 'Notes',
          color: 'is-notes'
        },
        {
          value: 'comms',
          label: 'Comms',
          color: 'is-texts'
        },
        {
          value: 'activities',
          label: 'Activities',
          color: 'is-activities'
        },
      ],
    }
  },
  mounted() {
    this.setupTimelineSettings()
  },
  computed: {
    leadTimelineSettings() {
      return this.$store.getters.authUser.lead_timeline_settings
    },
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        created_at: null,
        createdBy: {
          display_name: null,
        }
      };
    },
    recordCreatedAt() {
      return dates.formatAsDateTime(this.record.created_at);
    },
    recordCreatedBy() {
      return this.record.createdBy.display_name;
    },
    notes() {
      return (this.$store.state.activeRecord.notes.data) ? this.$store.state.activeRecord.notes.data : []
    },
    communicationLogs() {
      return (this.$store.state.activeRecord.communicationLogs.data) ? this.$store.state.activeRecord.communicationLogs.data : []
    },
    activities() {
      return (this.$store.state.activeRecord.activities.data) ? this.$store.state.activeRecord.activities.data : []
    },
    timelineItems() {
      let notes = [];
      let comms = [];
      let activities = [];

      if (this.selectedFilters.includes('notes')) {
        notes = this.notes;
      }

      if (this.selectedFilters.includes('comms')) {
        comms = this.communicationLogs;
      }

      if (this.selectedFilters.includes('activities')) {
        activities = this.activities;
      }

      return [
        ...notes,
        ...comms,
        ...activities,
      ]
    }
  },
  methods: {
    setupTimelineSettings() {
      if (! this.leadTimelineSettings) return;

      this.selectedFilters = this.selectedFilters.filter(filter => {
        return this.leadTimelineSettings.includes(filter)
      })
    },
    updateSelectedItems(value) {
      this.selectedFilters = value;
      api.users.updateLeadTimelineSettings(LocalStorage.getAuthUser().id, {lead_timeline_settings: this.selectedFilters})
        .then((res) => {})
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
